export default __webpack_public_path__ + "static/media/MMP_BB_STD Guide_2025.c7c5f4ff.pdf";